import type { Question } from '@/features/surveys/api';

/**
 * アンケート回答を画面に出せる文字列へ整える（D-083・D-158）。
 *
 * 設問定義（`Question[]`）から「設問文」「選択肢の表示名」を引き、回答値を日本語に
 * 直す。バックエンドの `services/survey_answer_format.py` と同じロジック
 * （個別回答一覧に内部コード・生JSONをそのまま出していた不具合の修正）。
 */

/** question_id → 設問文 の対応を作る */
export function questionLabels(questions: Question[]): Record<string, string> {
  const labels: Record<string, string> = {};
  for (const q of questions) labels[q.id] = q.label || q.id;
  return labels;
}

/** question_id → (値 → 表示名) の対応を作る。選択肢は options、マトリクスの行は rows */
export function questionChoices(questions: Question[]): Record<string, Record<string, string>> {
  const result: Record<string, Record<string, string>> = {};
  for (const q of questions) {
    const mapping: Record<string, string> = {};
    for (const entry of [...(q.options ?? []), ...(q.rows ?? [])]) {
      mapping[entry.value] = entry.label || entry.value;
    }
    if (Object.keys(mapping).length > 0) result[q.id] = mapping;
  }
  return result;
}

/** 設問の型に関わらず、画面に出せる文字列へ整える。辞書に無い値は隠さずそのまま出す */
export function answerText(value: unknown, choices?: Record<string, string>): string {
  const lookup = choices ?? {};
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) {
    return value.map((v) => lookup[String(v)] ?? String(v)).join('、');
  }
  if (typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>)
      .map(([k, v]) => `${lookup[k] ?? k}: ${lookup[String(v)] ?? String(v)}`)
      .join('、');
  }
  return lookup[String(value)] ?? String(value);
}
